module.exports = __webpack_public_path__ + "media/images/vp/icon.notifications.red-beb601a6527fb6a9ee8aca34fc6c192a.png";